<template>
     <div class="card">
                            <h4 class="card-title">
                            <strong>NEW TRAINING</strong>
                            </h4>
                            <div class="card-body">
                            <div class="py-30 text-center">
                                <div class="pb-10">
                                    <h5> Add New Training Courses</h5>
                                    <p class="mb-10">Fill all sub topics and their contents.</p>
                                </div>
                                <div>
                                <a class="btn btn-sm btn-round btn-primary" href="#" @click="openForm">Add New</a>
                                </div>
                            </div>
                            </div>
                        </div>
</template>

<script>
export default {
    methods: {
        openForm() {
            this.$emit('addNew')
        },
    }
}
</script>